import { render, staticRenderFns } from "./lazada.vue?vue&type=template&id=f6472370&scoped=true"
import script from "./lazada.vue?vue&type=script&lang=js"
export * from "./lazada.vue?vue&type=script&lang=js"
import style0 from "./lazada.vue?vue&type=style&index=0&id=f6472370&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f6472370",
  null
  
)

export default component.exports